import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Decorative only: callers announce the loading state in text. */
export function Spinner({ className }: { className?: string }) {
  return <Loader2 aria-hidden="true" className={cn('h-4 w-4 animate-spin', className)} />;
}
